/* 분류(카테고리·필터) S3 정본 — official/taxonomy.json 게시/로드 (26.07.03-admin §3).
   앱(ExampleTaxonomy.tryParse)은 {cats|categories:[{id,label}], filters|tags:[{id,label}]}
   를 관용 파싱하고 여분 필드(color 등)는 무시, 절대 throw 하지 않는다. 게시되면
   ① 라벨 단일 정본(다른 PC 에서 localStorage 유실 방지) ② 예제 0개 카테고리도 앱 노출.
   미게시/404 = 앱 폴백(안전). s3.js 동결 시그니처만 사용. */
import { getJsonAnon, putObject } from '../../api/s3.js';
import { CODE_BUCKET_URL } from '../../config/env.js';

export const TAXONOMY_KEY = 'official/taxonomy.json';
const url = () => (CODE_BUCKET_URL || '') + '/' + TAXONOMY_KEY;

/* 게시본 로드 — 없음(404/403)·형태 미상 → null(로컬 유지). */
export async function loadTaxonomy() {
  let json;
  try {
    json = await getJsonAnon(url());
  } catch (e) {
    if (e && (e.status === 404 || e.status === 403)) return null;
    throw new Error(`분류(taxonomy)를 읽지 못했습니다: ${e && e.message ? e.message : e}`);
  }
  const any = ['cats', 'filters', 'engrave_cats', 'engrave_filters'].some((k) => Array.isArray(json[k]));
  if (!json || !any) return null;
  return {
    cats: Array.isArray(json.cats) ? json.cats : [],
    filters: Array.isArray(json.filters) ? json.filters : [],
    // ★ null = "게시본에 아직 그 키가 없음" → 호출부가 로컬 값을 유지한다.
    //   []   = "비우도록 게시됨"        → 호출부가 로컬을 비운다. 둘을 구분해야 한다.
    engraveCats: Array.isArray(json.engrave_cats) ? json.engrave_cats : null,
    engraveFilters: Array.isArray(json.engrave_filters) ? json.engrave_filters : null,
    publishedAt: json.published_at || null,
  };
}

/* 게시 — 코드 예제 축(cats/filters) + 그림·툴패스 축(engrave_cats/engrave_filters)을 단일 PUT.
   앱 ExampleTaxonomy.tryParse 는 cats|categories / filters|tags 만 읽고 **미지 필드는 skip**
   하므로, engrave_* 키를 추가해도 구버전 앱에 회귀가 없다. 반환: published_at. */
export async function publishTaxonomy(getCredentials, { cats, filters, engraveCats, engraveFilters }) {
  const published_at = new Date().toISOString();
  const body = { schema: 1, published_at, cats: cats || [], filters: filters || [] };
  // 넘어오지 않은 축은 아예 쓰지 않는다(실수로 기존 게시본을 비우지 않도록).
  if (Array.isArray(engraveCats)) body.engrave_cats = engraveCats;
  if (Array.isArray(engraveFilters)) body.engrave_filters = engraveFilters;
  await putObject(getCredentials, TAXONOMY_KEY, JSON.stringify(body), 'application/json');
  return published_at;
}
